// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
.checkbox-switch {
  --track-width: 30px;
  --track-padding: 2px;
  --track-height: 15px;
  --track-button-size: calc(var(--track-height) - var(--track-padding) * 2);
  --track-move-length: calc((var(--track-width) - var(--track-padding)) / 2);
  --track-radius: 10px;
  display: contents;
  .switch-container {
    margin-bottom: calc(var(--spacing, 0.25rem) * 0) !important;
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing, 0.25rem) * 2);
    .switch-track {
      position: relative;
      display: inline-block;
      flex-shrink: 0;
      width: var(--track-width);
      height: var(--track-height);
    }
    &:has(input:disabled) {
      cursor: not-allowed;
      opacity: 70%;
    }
    .switch-label {
      -webkit-user-select: none;
      user-select: none;
      font-size: 14px;
    }
    input {
      height: calc(var(--spacing, 0.25rem) * 0);
      width: calc(var(--spacing, 0.25rem) * 0);
      opacity: 0%;
    }
    .switch-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: .3s;
      border-radius: var(--track-radius);
    }
    .switch-slider:before {
      position: absolute;
      content: "";
      height: var(--track-button-size);
      width: var(--track-button-size);
      left: var(--track-padding);
      bottom: var(--track-padding);
      background-color: white;
      transition: .3s;
      border-radius: 50%;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
    input:checked + .switch-slider {
      background-color: #4CAF50;
    }
    input:disabled + .switch-slider {
      pointer-events: none;
    }
    input:checked + .switch-slider:before {
      transform: translateX(var(--track-move-length));
    }
    input:focus + .switch-slider {
      box-shadow: 0 0 1px #4CAF50;
    }
  }
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/checkbox-switch/checkbox-switch.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACEA;EACI,mBAAoB;EACpB,oBAAqB;EACrB,oBAAqB;EACrB,yEAA0E;EAC1E,0EAA2E;EAC3E,oBAAqB;EAEd,iBAAQ;EAEf;IAC0C,2DAAK;IAApC,oBAAW;IAAC,mBAAY;IAAC,sCAAK;IAErC;MACW,kBAAQ;MAAC,qBAAY;MAAC,cAAQ;MACrC,yBAA0B;MAC1B,2BAA4B;IAC/B;IAED;MACW,mBAAkB;MAAC,YAAU;IACvC;IAED;MACW,yBAAW;MAAX,iBAAW;MAClB,eAAgB;IACnB;IAID;MACyB,yCAAG;MAAP,wCAAG;MAAb,WAAS;IACnB;IAID;MACI,kBAAmB;MACnB,eAAgB;MAChB,MAAO;MACP,OAAQ;MACR,QAAS;MACT,SAAU;MACV,sBAAuB;MACvB,eAAgB;MAChB,kCAAmC;IACtC;IAID;MACI,kBAAmB;MACnB,WAAY;MACZ,gCAAiC;MACjC,+BAAgC;MAChC,0BAA2B;MAC3B,4BAA6B;MAC7B,uBAAwB;MACxB,eAAgB;MAChB,kBAAmB;MACnB,wCAAyC;IAC5C;IAID;MACI,yBAA0B;IAC7B;IAED;MACI,oBAAqB;IACxB;IAED;MACI,+CAAgD;IACnD;IAID;MACI,2BAA4B;IAC/B;EACJ;AACJ","sourcesContent":[null,"@reference '../../../assets/css/main.css';\r\n\r\n.checkbox-switch {\r\n    --track-width: 30px;\r\n    --track-padding: 2px;\r\n    --track-height: 15px;\r\n    --track-button-size: calc(var(--track-height) - var(--track-padding) * 2);\r\n    --track-move-length: calc((var(--track-width) - var(--track-padding)) / 2);\r\n    --track-radius: 10px;\r\n\r\n    @apply contents;\r\n\r\n    .switch-container {\r\n        @apply inline-flex items-center gap-2 mb-0!;\r\n\r\n        .switch-track {\r\n            @apply relative inline-block shrink-0;\r\n            width: var(--track-width);\r\n            height: var(--track-height);\r\n        }\r\n\r\n        &:has(input:disabled) {\r\n            @apply cursor-not-allowed opacity-70;\r\n        }\r\n\r\n        .switch-label {\r\n            @apply select-none;\r\n            font-size: 14px;\r\n        }\r\n\r\n        /* Ẩn input gốc */\r\n\r\n        input {\r\n            @apply opacity-0 w-0 h-0;\r\n        }\r\n\r\n        /* Thanh trượt */\r\n\r\n        .switch-slider {\r\n            position: absolute;\r\n            cursor: pointer;\r\n            top: 0;\r\n            left: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n            background-color: #ccc;\r\n            transition: .3s;\r\n            border-radius: var(--track-radius);\r\n        }\r\n\r\n        /* Nút tròn */\r\n\r\n        .switch-slider:before {\r\n            position: absolute;\r\n            content: \"\";\r\n            height: var(--track-button-size);\r\n            width: var(--track-button-size);\r\n            left: var(--track-padding);\r\n            bottom: var(--track-padding);\r\n            background-color: white;\r\n            transition: .3s;\r\n            border-radius: 50%;\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n        }\r\n\r\n        /* Trạng thái khi ON */\r\n\r\n        input:checked + .switch-slider {\r\n            background-color: #4CAF50; /* Màu xanh lá đặc trưng */\r\n        }\r\n\r\n        input:disabled + .switch-slider {\r\n            pointer-events: none;\r\n        }\r\n\r\n        input:checked + .switch-slider:before {\r\n            transform: translateX(var(--track-move-length));\r\n        }\r\n\r\n        /* Trạng thái Focus (hỗ trợ phím Tab) */\r\n\r\n        input:focus + .switch-slider {\r\n            box-shadow: 0 0 1px #4CAF50;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
